import ProdutoTable from './ClienteTable';

export default ProdutoTable;
